import React from 'react';
import { Link } from '../../../env';
const Home = ({ handleMain }) => {
    const Introduction = [
        {
            title: 'Revolutionize Your Engine with IRSystemTuning',
            describtion: `At the heart of every high-performance vehicle is an engine built to exceed limits. With IRSystemTuning's remap and tuning software, unleash the true potential of your engine. Our software precisely adjusts various engine parameters such as fuel injection rates, air to fuel ratios, and ignition timing to boost performance, enhance efficiency, and improve drivability. Experience a seamless transformation that not only optimizes power output but also ensures sustainability with improved fuel economy. Whether you're looking to gain more horsepower or enhance torque, IRSystemTuning provides the tools to fine-tune every aspect of your engine's functionality. Transform your vehicle with the technology designed to elevate your driving experience, where every modification is a step towards perfection.`,
            img: `${Link}assets/Icons/engine2.png`
        },
        {
            title: 'Advanced CPU-Inspired Vehicle Optimization',
            describtion: `Transform your vehicle's performance with our software, designed to integrate the precision and efficiency of CPU technology into automotive enhancement. Our solution redefines engine management, optimizing fuel efficiency and power output through sophisticated recalibration techniques. By mirroring the processing power of a CPU, it adjusts critical engine parameters in real-time, ensuring each adjustment is perfectly tuned to your driving conditions.

                        Experience seamless performance upgrades with our dynamic adaptation algorithms that continuously learn and adjust to your vehicle’s needs. Safeguard your engine with built-in diagnostics that preemptively detect and correct inefficiencies, embodying the reliability and foresight of advanced computing. Step into the future of vehicle tuning with IRSystemTuning Software, where technology and performance converge for unmatched results`,
            img: `${Link}assets/Icons/electronin.png`
        }
    ]
    return (
        <div className='w-full min-h-screen overflow-y-scroll bg-[#283747] relative'>
            <div className='w-full sticky top-0 left-0 z-20 flex justify-end py-5 px-6'>
                <a href='/'><img src={`${Link}assets/Icons/return.png`} className='w-[50px] rounded-full p-2 border-2 border-white bg-[#1a5276]' onClick={handleMain} /></a>
            </div>
            <div className='w-full min-h-screen absolute top-0 left-0'>
                {
                    Introduction.map((item, index) => {
                        return (<>
                            <div className='w-full mt-20'>
                                <div className='w-full text-center'>
                                    <span className='text-white text-xl poppins-medium'>{item.title}</span>
                                </div>
                                <div className='w-full mt-16 flex justify-center'>
                                    <img src={item.img} className='w-[300px]'/>
                                </div>
                                <div className='w-full py-10 px-5 text-white text-justify poppins-regular'>
                                    {item.describtion}
                                </div>
                            </div>
                        </>)
                    })
                }
            </div>
        </div>
    );
}

export default Home;
